<template>
  <nuttrema-layout-content>

    <template slot="header">
      <programs-standard-header
        :meta="meta"
        :edit.sync="edit"
        :ProgramDetails="ProgramDetails">
      </programs-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="ProgramDetails.fetching || PersonOccupiedDates.fetching"></nuttrema-loader>
      <form-program-change-status
         v-else
        :id="id"
        :edit.sync="edit"
        :ProgramDetails="ProgramDetails"
        :PersonOccupiedDates="PersonOccupiedDates"
        @transition="onTransition"
        @sendActiveProgramNotification="onSendActiveProgramNotification">
      </form-program-change-status>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';
import { get } from 'lodash';

import { PERSON_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import ProgramsStandardHeader from 'components/pages/professional/programs/shared/details/cmpt-programs-standard-header';

import FormProgramChangeStatus from './form-program-change-status';

export default {
  name: 'page-program-change-status',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
      participantID: null,
    };
  },
  components: {
    NuttremaLayoutContent,
    ProgramsStandardHeader,
    FormProgramChangeStatus,
  },
  computed: {
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
    PersonOccupiedDates() {
      return this.$store.getters.PersonOccupiedDates(this.participantID);
    },
  },
  methods: {
    ...mapActions([
      'ProgramStatusTransition',
      'ProgramSendNotification',
    ]),
    onTransition({ transition, payload }) {
      this.ProgramStatusTransition({ id: this.id, type: this.type, transition, payload }).then(() => {
        this.successNotification({ label: 'label.status' });
      }).catch(() => {
        this.errorNotification();
      });
    },
    onSendActiveProgramNotification(payload) {
      this.ProgramSendNotification({ id: this.id, type: this.type, payload }).then(() => {
        this.successNotification({ message: 'message.default_success_send_message', label: 'label.email' });
      }).catch(() => {
        this.errorNotification();
      });
    },
  },
  created() {
    this.participantID = get(this.ProgramDetails, 'data.Participant.id') || -1;
    if (this.participantID !== -1) this.$store.dispatch('GetPersonOccupiedDates', { id: this.participantID, type: PERSON_KEYS.participant });
    else this.$store.dispatch('InitPersonOccupiedDates', { id: this.participantID });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonOccupiedDates', { id: this.participantID });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/settings/status/page-program-change-status.vue